import { mclOpen } from '../api/Mcl';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const response = await mclOpen.get('/auth/refresh', {
            withCredentials: true
        });
        setAuth(prev => {
            console.log('refresh:', JSON.stringify(prev));
            console.log('data:', response.data.accessToken);
            return {
                ...prev,
                roles: response.data.roles,
                accessToken: response.data.accessToken
            }
        });
        return response.data.accessToken;
    }
    return refresh;
};

export default useRefreshToken;
